import { component } from 'picoapp';

export default component(async (node) => {
  /**
   * Functions
   */
  const init = () => {
    if (document.referrer.includes(window.theme.storeUrl)) {
      node.href = document.referrer;
    }
  };

  /**
   * Init
   */
  init();
});
